/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { OrderingDirection } from '@g17eco/types/common';
import { naturalSort } from '.';

export const sortEffectiveDateDesc = (a: { effectiveDate: string }, b: { effectiveDate: string }) => {
  if (a.effectiveDate < b.effectiveDate) {
    return 1;
  }

  if (a.effectiveDate > b.effectiveDate) {
    return -1;
  }
  return 0;
}

export const sortEffectiveDateAsc = (a: { effectiveDate: string }, b: { effectiveDate: string }) => {
  if (a.effectiveDate < b.effectiveDate) {
    return -1;
  }

  if (a.effectiveDate > b.effectiveDate) {
    return 1;
  }
  return 0;
};

export interface SortableItem {
  sortTitle?: string;
  unitCount?: number;
}

export interface SortType<T = SortableItem> { field: keyof T, asc: boolean }
export const Sort: { [key: string]: SortType } = {
  TitleAsc: {
    field: 'sortTitle',
    asc: true
  },
  TitleDesc: {
    field: 'sortTitle',
    asc: false
  },
  UnitCountAsc: {
    field: 'unitCount',
    asc: true
  },
  UnitCountDesc: {
    field: 'unitCount',
    asc: false
  }
}

export function sortItems<T = SortableItem>(cards: T[], sortType: SortType<T>) {
  const field = sortType.field;
  const newCards = cards.slice().sort((a, b) => naturalSort(String(a[field]), String(b[field])));

  if (sortType.asc) {
    return newCards;
  } else {
    return newCards.reverse();
  }
}


type DateAndId = { date: string; _id: string };
export const sortByDateAndId = (a: DateAndId, b: DateAndId) => {
  if (a.date > b.date) return -1;
  if (a.date < b.date) return 1;

  // fallback to _id when date are equal.
  if (a._id > b._id) return -1;
  if (a._id < b._id) return 1;

  return 0;
};

export const DIRECTION_LABEL: Record<OrderingDirection, string> = {
  [OrderingDirection.Asc]: 'Asc',
  [OrderingDirection.Desc]: 'Desc',
  [OrderingDirection.Default]: 'Default',
};
